export default {


    PAGE_BASE:'/kr',
    API_URL: '/ko/api/v1',

    BUTTON_BG_COLOR:'#ffcf30', //'#cba003',//'#38afff', //
    BUTTON_TEXT_COLOR:'#222222',

}